<template>
  <div class="easylogin">
    <div v-if="!isLogin"
         class="loginloading">
      <img width="300"
           src="@/assets/simple/loginloading.gif"
           alt="">
    </div>
    <div v-else
         class="error">
      <img width="320"
           src="@/assets/simple/loginerror.png"
           alt="">
    </div>
  </div>
</template>

<script>
import { easynet,ssoLogin } from "@/api/easynet";
import { mapActions } from "vuex";
import { listLib } from '@/api/lib'
export default {
  data () {
    return {
      isLogin: false
    }
  },
  methods: {

    ...mapActions(["setLoginInfo"]),
    ...mapActions(["setRoleCode"]),
    ...mapActions(["setToken"]),
    ...mapActions(["setCreateUid"]),
    ...mapActions(["setPowers"]),

    async loginAsync (val) {
      let { status, data, message, errors } = await easynet(val);
      if (status) {
        this.setLoginInfo(data)
        this.setToken(data.token)
        this.setCreateUid(data.id)

        localStorage.setItem('token', JSON.stringify(data.token))
        localStorage.setItem('createUid', data.id)

        let libData = await listLib({ pageSize: 100 });
        let libList = []
        if (libData.status) {
          for (let i = 0; i < libData.data.length; i++) {
            if (libData.data[i].status === 1) {
              libList.push('lib-' + libData.data[i].id)
            }
          }
        } else {
          this.$message.error(libData.message)
        }

        if (data.powers[0] === 'admin') {
          let powersMy = [
            'allowLogin',
            'mySetting',
            'desktopAuthor',
            'appointPictureNeed',
            'browseUnPicture',
            'allowMyGallery',
            'createAtlas',
            'openLocalDisk',
            'allowGalleryCenter',
            'advSearchPicture',
            'baseSearchPicture',
            'selectPicture',
            'allowApply',
            'pictureDownload',
            'picturePush',
            'pictureShare',
            'allowTransmit',
            'browseDownload',
            'browsePush',
            'browseShare',
            'allowGather',
            'manageAllPictureActivity',
            'manageAllPictureNeed',
            'myPictureActivity',
            'manageAllActivityLive',
            'myActivityLive',
            'myPictureNeed',
            'activityThemeConfig',
            'baseConfig',
            'libConfig',
            'pushConfig',
            'roleConfig',
            'systemLogs',
            'manageAtlas',
            'myFace',
            'browseActivityArticle',
            'manageActivityArticle',
            'manageAllActivityArticle',
            'myAtlas',
            'checkUserAuthInfo',
            'searchUserAuthInfo',
            'outputUserAuthInfo',
            'checkPictureArticle',
            'myPictureArticleFilter',
            'manageAllPictureArticleFilter',
            'outputPictureArticleFilter',
            'checkPictureArticleFilter',
            'rejectPictureArticleFilter',
            'userConfig',
            'textConfig',

            'createPrivateAtlas',
            'createPublicAtlas',

            'allowAiCenter',
            'securityConfig',
            'dataAnalysis',
            'manageIntelligentNode',
            'allowOperationCenter',
            'manageNas',
            'manageThirdPartyAccess',
            'operationCommand',
            'systemLogs',
            'browseWebsiteCarousel',
            'manageWebsiteCarousel',
            'browseWebsiteInfo',
            'manageWebsiteInfo',
            'websiteConfig',
            'justAdmin'
          ]
          let myPowers = powersMy.concat(libList)
          this.setPowers(myPowers)
          this.judgeFirstPage(myPowers)
        } else {
          this.setPowers(data.powers)
          this.judgeFirstPage(data.powers)
        }



        this.$message.success('登录成功！')

      } else {
        this.isLogin = true
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }

    },

    async ssoLoginAsync (val) {
      let { status, data, message, errors } = await ssoLogin(val);
      if (status) {
        this.setLoginInfo(data)
        this.setToken(data.token)
        this.setCreateUid(data.id)

        localStorage.setItem('token', JSON.stringify(data.token))
        localStorage.setItem('createUid', data.id)

        let libData = await listLib({ pageSize: 100 });
        let libList = []
        if (libData.status) {
          for (let i = 0; i < libData.data.length; i++) {
            if (libData.data[i].status === 1) {
              libList.push('lib-' + libData.data[i].id)
            }
          }
        } else {
          this.$message.error(libData.message)
        }

        if (data.powers[0] === 'admin') {
          let powersMy = [
            'allowLogin',
            'mySetting',
            'desktopAuthor',
            'appointPictureNeed',
            'browseUnPicture',
            'allowMyGallery',
            'createAtlas',
            'openLocalDisk',
            'allowGalleryCenter',
            'advSearchPicture',
            'baseSearchPicture',
            'selectPicture',
            'allowApply',
            'pictureDownload',
            'picturePush',
            'pictureShare',
            'allowTransmit',
            'browseDownload',
            'browsePush',
            'browseShare',
            'allowGather',
            'manageAllPictureActivity',
            'manageAllPictureNeed',
            'myPictureActivity',
            'manageAllActivityLive',
            'myActivityLive',
            'myPictureNeed',
            'activityThemeConfig',
            'baseConfig',
            'libConfig',
            'pushConfig',
            'roleConfig',
            'systemLogs',
            'manageAtlas',
            'myFace',
            'browseActivityArticle',
            'manageActivityArticle',
            'manageAllActivityArticle',
            'myAtlas',
            'checkUserAuthInfo',
            'searchUserAuthInfo',
            'outputUserAuthInfo',
            'checkPictureArticle',
            'myPictureArticleFilter',
            'manageAllPictureArticleFilter',
            'outputPictureArticleFilter',
            'checkPictureArticleFilter',
            'rejectPictureArticleFilter',
            'userConfig',
            'textConfig',

            'createPrivateAtlas',
            'createPublicAtlas',

            'allowAiCenter',
            'securityConfig',
            'dataAnalysis',
            'manageIntelligentNode',
            'allowOperationCenter',
            'manageNas',
            'manageThirdPartyAccess',
            'operationCommand',
            'systemLogs',
            'browseWebsiteCarousel',
            'manageWebsiteCarousel',
            'browseWebsiteInfo',
            'manageWebsiteInfo',
            'websiteConfig',
            'justAdmin'
          ]
          let myPowers = powersMy.concat(libList)
          this.setPowers(myPowers)
          this.judgeFirstPage(myPowers)
        } else {
          this.setPowers(data.powers)
          this.judgeFirstPage(data.powers)
        }



        this.$message.success('登录成功！')

      } else {
        this.isLogin = true
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }

    },

    //判断初次登陆的访问页面
    judgeFirstPage (val) {
      // console.log(val)
      if (val.indexOf('desktopAuthor') !== -1) {
        this.$router.push('/container')
        localStorage.setItem('firstPage', '/container')

      } else if (val.indexOf('desktopEditor') !== -1) {
        this.$router.push('/desktop/editor')
        localStorage.setItem('firstPage', '/desktop/editor')

      } else if (val.indexOf('desktopManager') !== -1) {
        this.$router.push('/desktop/manager')
        localStorage.setItem('firstPage', '/desktop/manager')

      } else if (val.indexOf('allowMyGallery') !== -1) {
        this.$router.push('/myLib/myAtlas')
        localStorage.setItem('firstPage', '/myLib/myAtlas')

      } else if (val.indexOf('allowGalleryCenter') !== -1) {
        this.$router.push('/pictureCenter')
        localStorage.setItem('firstPage', '/pictureCenter')

      } else if (val.indexOf('allowTransmit') !== -1 && val.indexOf('browseShare') !== -1) {
        this.$router.push('/shareAndPush/myShare')
        localStorage.setItem('firstPage', '/shareAndPush/myShare')

      } else if (val.indexOf('allowTransmit') !== -1 && val.indexOf('browsePush') !== -1) {
        this.$router.push('/shareAndPush/myPush')
        localStorage.setItem('firstPage', '/shareAndPush/myPush')

      } else if (val.indexOf('allowTransmit') !== -1 && val.indexOf('browseDownload') !== -1) {
        this.$router.push('/shareAndPush/myDownload')
        localStorage.setItem('firstPage', '/shareAndPush/myDownload')

      }  else if (val.indexOf('baseConfig') !== -1) {
        this.$router.push('/config/basic')
        localStorage.setItem('firstPage', '/desktop/manager')

      } else if (val.indexOf('libConfig') !== -1) {
        this.$router.push('/config/picManage')
        localStorage.setItem('firstPage', '/config/picManage')

      } else if (val.indexOf('roleConfig') !== -1) {
        this.$router.push('/config/roleManage')
        localStorage.setItem('firstPage', '/config/roleManage')

      } else if (val.indexOf('userConfig') !== -1) {
        this.$router.push('/config/userManage')
        localStorage.setItem('firstPage', '/config/userManage')

      } else if (val.indexOf('systemLogs') !== -1) {
        this.$router.push('/config/journalManage')
        localStorage.setItem('firstPage', '/config/journalManage')

      } else if (val.indexOf('pushConfig') !== -1) {
        this.$router.push('/config/pushChannelManage')
        localStorage.setItem('firstPage', '/config/pushChannelManage')

      } else if (val.indexOf('activityThemeConfig') !== -1) {
        this.$router.push('/config/activityThemeManage')
        localStorage.setItem('firstPage', '/config/activityThemeManage')

      }
    },
  },
  created () {
    
    if(localStorage.getItem('token')){
      let localToken = localStorage.getItem('token')
      if(localToken.indexOf('"') == -1){
        localStorage.setItem('token',JSON.stringify(localToken))
      }
    }

    if (this.$route.query.accessToken) {
      this.$message({
        showClose: true,
        message: '正在登录中……',
        duration: 1000
      })
      this.loginAsync({
        accessToken: this.$route.query.accessToken
      })
    }

    if (this.$route.query.commonToken) {
      this.$message({
        showClose: true,
        message: '正在登录中……',
        duration: 1000
      })
      this.ssoLoginAsync({
        accessToken: this.$route.query.commonToken
      })
    }
    
    if(!this.$route.query.accessToken && !this.$route.query.commonToken){
      this.$message.warning('无法获取Token!')
    }
  }

}
</script>

<style lang="scss" scoped>
.easylogin {
  background: #ffffff;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
